var React = require('react');

function StatusRunningOutline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},[React.createElement("path",{"d":"M16 30c7.73 0 14-6.27 14-14S23.73 2 16 2 2 8.27 2 16s6.27 14 14 14zm0 2C7.16 32 0 24.84 0 16S7.16 0 16 0s16 7.16 16 16-7.16 16-16 16z","key":0}),React.createElement("path",{"d":"M23 18c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-7 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-7 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z","key":1})]));
}

StatusRunningOutline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = StatusRunningOutline;

StatusRunningOutline.default = StatusRunningOutline;
